import { render, staticRenderFns } from "./fee_config_edit.vue?vue&type=template&id=0531ff98&scoped=true"
import script from "./fee_config_edit.vue?vue&type=script&lang=js"
export * from "./fee_config_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531ff98",
  null
  
)

export default component.exports